import { render } from "./Suppliers.vue?vue&type=template&id=0f4f4c8c&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"

import "./Suppliers.vue?vue&type=style&index=0&id=0f4f4c8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4f4c8c"]])

export default __exports__